import { getHost } from "@src/env";
import type { Radio } from "@src/types";
import { useQuery } from "@tanstack/react-query";

import { Api } from "@src/services/api";

export function useOfflineAudiosQuery(radio: Radio) {
  return useQuery({
    enabled: false, // aguarda chamar o refetch
    queryKey: ["offlineAudios", radio.name],
    queryFn: async () => {
      const host = getHost();
      const audioLinks = await Api.getAudioLinks(radio.name);
      const cacheableAudioLinks = audioLinks.map((link) => {
        const url = `${host}/api/play-audio/${radio.name}/${link}`;
        return encodeURI(url);
      });
      return { cacheableAudioLinks };
    },
  });
}
